
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/address/[address]",
      function () {
        return require("private-next-pages/address/[address].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/address/[address]"])
      });
    }
  